import { PRODUCT_CATEGORIES, BUSINESS, MEDIA } from "@/data";
import { SectionHeading } from "./Buttons";
import * as Icons from "lucide-react";

const iconFor = (id) => ({
  iphones: Icons.Smartphone,
  android: Icons.Smartphone,
  tablets: Icons.Tablet,
  watches: Icons.Watch,
  chargers: Icons.Cable,
  cases: Icons.ShieldCheck,
  audio: Icons.Headphones,
  storage: Icons.HardDrive,
}[id] || Icons.Package);

export default function ProductShowcase() {
  return (
    <section id="products" data-testid="products-section" className="relative bg-white py-20 md:py-28 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-end mb-12 md:mb-16">
          <SectionHeading
            eyebrow="In-Store Inventory"
            title={<>Phones, tablets &amp; accessories — <span className="text-brand-red">available in-store.</span></>}
            sub="We carry unlocked phones, tablets, Apple Watches, chargers, cases, screen protectors, headphones, and more. Inventory changes daily, so call or visit to confirm what's available."
            testid="products-heading"
          />
          <div className="hidden lg:flex flex-col justify-center relative h-72 rounded-3xl overflow-hidden card-soft p-8 bg-gradient-to-br from-green-50 via-white to-orange-50">
            <div className="text-xs font-bold uppercase tracking-widest text-brand-red mb-2">Real local stock</div>
            <div className="font-display text-2xl font-extrabold text-brand-navy leading-tight">Walk in. See it.<br />Take it home.</div>
            <div className="mt-3 text-sm text-slate-600 max-w-[18rem]">Latest iPhones, premium accessories &amp; more — refreshed daily.</div>
            <div className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-brand-red w-fit">
              <Icons.Smartphone className="w-4 h-4" />
              Inventory updated daily
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {PRODUCT_CATEGORIES.map((p) => {
            const Icon = iconFor(p.id);
            return (
              <a
                key={p.id}
                href={`tel:${BUSINESS.phoneTel}`}
                data-testid={`product-card-${p.id}`}
                className="card-soft card-soft-hover p-5 md:p-6 group"
              >
                <div className="w-10 h-10 rounded-xl bg-slate-100 grid place-items-center mb-4 group-hover:bg-brand-red group-hover:scale-110 transition-all">
                  <Icon className="w-5 h-5 text-brand-red group-hover:text-white transition-colors" />
                </div>
                <h4 className="font-display font-extrabold text-brand-navy text-base md:text-lg leading-tight">{p.title}</h4>
                <p className="text-xs md:text-sm text-slate-600 mt-2 leading-relaxed">{p.desc}</p>
                <div className="mt-4 inline-flex items-center gap-1.5 text-xs font-bold text-brand-red group-hover:gap-2.5 transition-all">
                  <Icons.Phone className="w-3 h-3" />
                  Check Availability
                </div>
                {p.note && (
                  <div className="mt-3 text-[10px] font-bold uppercase tracking-wider text-slate-400">{p.note}</div>
                )}
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
